import { ProfilePage } from "../../../features/profile/profile-page/profile-page";
import { getAuth0AccessToken } from "../../../lib/auth0";
import { GetProfileServerSideProps } from "../index";

export default ProfilePage;

export const getServerSideProps: GetProfileServerSideProps = async ({
  req,
  res,
  params,
  query,
}) => {
  const accessToken = await getAuth0AccessToken(req, res);
  const props = await ProfilePage.prefetchData(params);
  const profile = props.profile;

  if (query.direct && query.r) {
    return {
      redirect: {
        statusCode: 301,
        destination: `/plan?r=${query.r}`,
      },
    };
  }

  if (profile && !profile.parentProfile) {
    return {
      redirect: {
        statusCode: 301,
        destination: `/${profile.username}`,
      },
    };
  }

  return {
    props: { ...props, accessToken },
  };
};
